<ngx-json-ld [json]="schema" *ngIf="schema"></ngx-json-ld>
<!-- <ins class="adsbygoogle"
     style="display:inline-block;width:300px;height:50px"
     ata-ad-client="ca-pub-6680423324157080" data-ad-slot="9395162496" data-adtest="on"></ins> -->
     <!-- <ins class="adsbygoogle" id="playerTopad"
     style="display:block"
     data-ad-format="fluid"
     data-ad-layout-key="-i2+f-1d-38+b7"
     data-ad-client="ca-pub-6680423324157080"
     data-ad-slot="5883292894"></ins> -->
     <!-- Player top display ad -->
<!-- <ins class="adsbygoogle" id="playerTopad"
style="display:inline-block;width:300px;height:50px"
data-ad-client="ca-pub-6680423324157080"
data-ad-slot="9505383529"></ins> -->
<!-- Top leaderboard ad -->
<!-- <div style="width: 300px; height: 90px;"> -->
<!-- <div appAdsense
     [adClient]="'ca-pub-6680423324157080'"
     [adSlot]="'9505383529'"
     [width]="'300px'"
     [height]="'90px'">
</div> -->
<ins id="playerTopad" class="adsbygoogle" style="display:block;" data-ad-client="ca-pub-6680423324157080" data-ad-slot="9505383529" data-ad-format="horizontal" data-full-width-responsive="true" data-adtest="on"></ins>
<!-- Another ad (medium rectangle) -->
<!-- <div appAdsense
     [adClient]="'ca-pub-6680423324157080'"
     [adSlot]="'1234567890'"
     [width]="'300px'"
     [height]="'250px'">
</div> -->
<div class="panel greyBG mainPlayer">
        <div class="options">
            <a  href="javascript:void(0)" *ngIf="!isfav" (click)="favouites(stationId , true)">
                <i class="fa fa-heart-o"  aria-hidden="true"></i>   </a>
              <a    *ngIf="isfav" (click)="unfavouites(stationId , false)">
              <i class="fa fa-heart " aria-hidden="true"></i>  </a>
            <!-- <a href="#"><i class="fa fa-heart-o"></i></a> -->
            <a href="javascript:void(0)"><i class="fa fa-share-alt" (click)="share()"></i></a>
        </div>
        <div class="thumb"><img *ngIf="stationDetail?.image" src="{{stationDetail?.image}}" alt="{{stationDetail?.name}}" onerror="this.onerror=null; this.src='../../assets/images/errornew.png';"></div>
        <div class="info">
            <h1 class="h1">{{stationDetail?.name}}</h1>
            <div class="description">
                <p><span>{{stationDetail?.genre}} <a class="moreInfoBtn" (click)="genreModal()" href="javascript:void(0)"><i class="fa fa-music"></i> More</a></span> 
                    
                    <a *ngIf="website == 'https://theonestopradio.com'" target="_blank" href="{{website}}">{{website}}</a>
                    <a *ngIf="website != 'https://theonestopradio.com'" target="_blank" rel="nofollow" href="{{website}}">{{website}}</a>
                </p>
            </div>
            <div class="playerRange">
                <div class="playBtn" *ngIf="!isloading && !isprevNext">
               
                    <i (click)="toggelPlayer($event,false)" [ngClass]="isDisabled ? 'disabled': '' || isprevNext ? 'disabled': '' " *ngIf="!isplaying && !isplayerror && !ispageload && !isprevNextplaying && !isprevNext" class="fa fa-play toggelPlayer"></i>

                    <i (click)="toggelPlayer($event,true)" [ngClass]="isDisabled ? 'disabled': '' || isprevNext ? 'disabled': '' "   *ngIf="isplaying && !isplayerror && !ispageload && !isprevNextplaying && !isprevNext" class="fa fa-pause"></i>

                    <!-- <i (click)="toggelPlayer($event,false)" [ngClass]="isDisabled ? 'disabled': '' || isprevNext ? 'disabled': '' " *ngIf="isprevNext" class="fa fa-play"></i> -->

                    <i (click)="pagestart()"   *ngIf="isplayerror && !isprevNextplaying && !isprevNext" class="fa fa-refresh"></i>

                    <i (click)="pagestart()"  [ngClass]="isDisabled ? 'disabled': '' || isprevNext ? 'disabled': '' "   *ngIf="ispageload" class="fa fa-play pagestart"></i>
                    
                    <i (click)="pagestart()"  [ngClass]="isDisabled ? 'disabled': '' || isprevNext ? 'disabled': '' "   *ngIf="!ispageload && isprevNext  && isprevNextplaying && !isprevNext" class="fa fa-play lastpagestart"></i>
                 
                
                </div>
             
                <div class="playBtn" *ngIf="isloading && !isprevNext">
                    <i   *ngIf="isloading" class="fa fa-spin fa-spinner"></i>
                </div>
                <div class="playBtn" *ngIf="isprevNext">
                    <i (click)="toggelPlayer($event,false)" [ngClass]="isDisabled ? 'disabled': '' || isprevNext ? 'disabled': '' " *ngIf="isprevNext" class="fa fa-play"></i>
                </div>
                <div class="range">
                    <span><i class="fa fa-circle"></i> Live</span>
                    <span>{{nFormatter(stationDetail?.play_count)}} Plays</span>
                </div>
            </div>
        </div>
    </div>
   
    <div class="panel greyBG playereco">
        <header class="panelHead">
            <span class="h5">Recommended Radio Stations</span>
            <!-- <div class="controls">
                <a class="prevBtn" href="javascript:void(0)"><i class="fa fa-angle-left"></i></a>
                <a class="nextBtn" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
            </div> -->
        </header>
        <div class="panelBody popularRadio">
            <owl-carousel [options]="SlideOptions" class="popularOwl" [items]="popularData" [carouselClasses]="['owl-theme', 'sliding']" >  
            <div class="radioList"  *ngFor="let popular of popularData let i = index" (click)="redirectTo(popular)" >
                    <a [routerLink]="popular?.slug"  (click)="store('home',i+1,popularData,popularData.length)">
                <div class="thumb"><img src="{{popular.image}}" alt="{{popular?.name}}"></div>
                <span class="h4">{{popular.name}}</span>
            </a>
            </div>
         </owl-carousel>
        </div>
    </div>
    <div class="playerAd">
        <ins class="adsbygoogle" style="display:block;" data-ad-client="ca-pub-6680423324157080" data-ad-slot="9395162496" data-ad-format="horizontal" data-full-width-responsive="true" data-adtest="on"></ins>
    </div>
    <span class="blankSpace"></span>
    <!-- <div class="nearMeAd">
        <ins class="adsbygoogle" style="display:block;" data-ad-client="ca-pub-6680423324157080" data-ad-slot="9395162496" data-ad-format="horizontal" data-full-width-responsive="true" data-adtest="on"></ins>
    </div> -->
    <!-- <div class="playerAd">
        <ins class="adsbygoogle" style="display:block" data-ad-format="autorelaxed" data-ad-client="ca-pub-6680423324157080" data-ad-slot="9618372783"></ins>
    </div> -->
    <div class="modal customModal shareModal" id="sharemodal" style="display: none;">
        <div class="modal-dialog">
            <header>
                <span class="title">Share</span>
                <a (click)="shareClose()" href="javascript:void(0)"><i class="fa fa-times"></i></a>
            </header>
            <share-buttons [showText]="true" [include]="['whatsapp','facebook','twitter','linkedin','telegram','sms','email','copy']" [url]="stationDetail?.sharelink"></share-buttons>
        </div>
    </div>
    <div class="modal customModal shareModal" id="genreModal" style="display: none;">
        <div class="modal-dialog">
            <header>
                <span class="title">More Information</span>
                <a (click)="genreModalClose()" href="javascript:void(0)"><i class="fa fa-times"></i></a>
            </header>
            <div class="infoDetail">
                <span class="yellow" *ngIf="stationDetail?.country_name"><strong>Country:</strong> <a routerLink="/country/{{stationDetail?.country_name}}-{{stationDetail?.country_code}}">{{stationDetail?.full_country}}</a></span>
                <span class="blue" *ngIf="stationDetail?.language"><strong>Language:</strong> <a routerLink="/language/{{stationDetail?.language_name}}-{{stationDetail?.language}}">{{stationDetail?.full_language}}</a></span>

                <span class="purple" *ngIf="stationDetail?.genre"><strong>Genre:</strong>
                     <!-- <a  *ngFor="let data of stationDetail?.gen_id let i = index"  routerLink="/genre/{{data}}">{{stationDetail?.full_genre[i]}}</a> -->
                     <span *ngFor="let data of stationDetail?.full_genre let i = index">
                        <a *ngIf="stationDetail?.gen_id[i]" routerLink="/genre/{{stationDetail?.gen_id[i]}}">{{data}}</a>
                        <a *ngIf="!stationDetail?.gen_id[i]" href="javascript:void(0)">{{data}}</a>
                        <span>,</span>
                     </span>
                
                    </span>
                <span class="red" *ngIf="stationDetail?.network_name"><strong>Network:</strong><a routerLink="/network/{{stationDetail?.network_name}}-{{stationDetail?.network_id}}">{{stationDetail?.full_network}}</a></span>
            </div>
        </div>
    </div>
    <div class="modal customModal errorView" style="display: none;" id="sharemodal">
        <div class="modal-dialog" style="padding: 20px;">
          <i class="fa fa-play-circle" aria-hidden="true"></i>
            <div class="btn-group">
                <a href="https://theonestopradio.com/getapp" target="_blank" class="btn btn-primary getApp">Get APP</a>
              <button  type="button" (click)="dismissModal()" class="btn btn-primary">OK</button>
            </div>
        </div>
      </div>

      <div class="modal1 customModal errorView" style="display: none;" id="deactivestation">
        <div class="modal-dialog" style="padding: 20px;">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            <!-- <button type="button" class="close" (click)="dismissModal()">&times;</button> -->
            <p style="margin: 0;">Unfortunately,  Radio is no longer broadcasting.</p>
            <div class="btn-group">
              <button  type="button" (click)="dismissModal()" class="btn btn-primary getApp">OK</button>
            </div>
        </div>
      </div>

